// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  /*.range-md .range-knob {
      background: #fff;
      border: 3px solid var(--ion-color-primary);
      width: 25px;
      height: 25px;
      top: 0px;
      left: 0px;
  }

  ion-range {
      padding-right: 20px;
      padding-left: 20px;
  }

  .range-md {
      padding-right: 20px;
      padding-left: 20px;
  }

  .item-md.item-block .item-inner {
      border: none;
  }*/
}
:host div {
  text-align: left;
  margin-left: 10px;
}
:host .eighty {
  /*margin-left: 30px;
  margin-right: 30px;*/
  width: 80%;
  margin-left: 0px;
  /*margin-left: 10%;*/
}
:host .range-md .range-knob {
  background: #fff;
  border: 3px solid var(--ion-color-primary);
  width: 25px;
  height: 25px;
  top: 0px;
  left: -12px;
}
:host .range-md .range-knob-min.range-knob-min .range-knob {
  background: #fff;
  border: 3px solid var(--ion-color-primary);
}
:host .item-md.item-block .item-inner {
  border: none;
}
:host ion-range {
  margin-left: 0px;
}
:host .range-md .range-knob-handle {
  margin-left: -10px;
}
:host .range-md {
  /*padding-right: 20px;*/
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
